export const setIframeAsLoaded = () => ({
  type: "IFRAME_LOADED"
});

/**
 *  Finds the element that was selected for entering edit mode
 * and dispatches an action to set it.
 *
 * @param {String} elementKey key of the selected element
 */
export const selectElement = (elementKey, editMode = true) => {
  return (dispatch, getState) => {
    const state = getState();
    const selectedElement = state.page.components.filter(
      i => i.key === elementKey
    )[0];
    dispatch(setSelectedElement(selectedElement, editMode));
  };
};

/**
 * Causes an update in our editor reducer setting the state
 * of selected to the received element, enabling editMode.
 *
 * @param {Object} element Object selected for editMode
 */
const setSelectedElement = (element, editMode) => {
  return {
    type: "SELECT_ELEMENT",
    payload: {
      selected: element,
      editMode
    }
  };
};

/**
 * Removes the current element select, thus disabling
 * editMode.
 */
export const unSelect = () => {
  return {
    type: "SELECT_ELEMENT",
    payload: {
      selected: null,
      editMode: true
    }
  };
};

/**
 *  Tells our state that we're dragging something, useful so
 *  we can style things when dragging something.
 */
export const startDrag = (origin, height, amount) => ({
  type: "DRAG_ACTION",
  payload: {
    dragging: true,
    dragSource: origin,
    dragSourceHeight: height,
    filesBeingDragged: amount,
    showingOverlay: true
  }
});

/**
 * Tells our state that we stopped dragging something, useful so
 * we can revert styles applied when dragging something.
 */
export const stopDrag = () => ({
  type: "DRAG_ACTION",
  payload: {
    dragging: false,
    dragSource: null,
    hoveringElement: null,
    hoverDirection: null,
    filesBeingDragged: null,
    showingOverlay: false
  }
});

export const changeOverlay = payload => ({
  type: "CHANGE_OVERLAY",
  payload
});

export const hoverAction = obj => ({
  type: "HOVER_ACTION",
  payload: obj
});

export const setError = errorObj => ({
  type: "SET_ERROR",
  payload: errorObj
});

export const startResize = elementKey => ({
  type: "START_RESIZE",
  payload: elementKey
});

export const endResize = () => ({
  type: "END_RESIZE"
});
